export const categoryData = [
    {
        value: 1,
        name: 'On'
    },
    {
        value: 2,
        name: 'Off'
    },

]
export const categoryData1 = [
    {
        value: 1,
        name: 'Followers'
    },
    {
        value: 2,
        name: 'Everyone'
    },
    {
        value: 3,
        name: 'No-One'
    },

]
export const mediaData = [
    {
        value: 1,
        name: 'Songs'
    },
    {
        value: 2,
        name: 'Album'
    },
    {
        value: 3,
        name: 'Samples'
    },
    {
        value: 4,
        name: 'Music Video'
    },
    {
        value: 5,
        name: 'Lesson'
    },
    {
        value: 6,
        name: 'Course'
    },
    {
        value: 7,
        name: 'Sheet Music'
    }

]

export const sortingData = [
    {
        value: 1,
        name: 'Relevance'
    },
    {
        value: 2,
        name: 'Date'
    },
    {
        value: 3,
        name: 'A-Z Order'
    }

]





